import { render, staticRenderFns } from "./i-slide-show-2.vue?vue&type=template&id=d3097336&scoped=true&"
import script from "./i-slide-show-2.vue?vue&type=script&lang=js&"
export * from "./i-slide-show-2.vue?vue&type=script&lang=js&"
import style0 from "./i-slide-show-2.vue?vue&type=style&index=0&id=d3097336&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3097336",
  null
  
)

export default component.exports